<template lang="pug">
div(class="flex justify-center")
  .yellow-square
  template(v-for="contents in block.innerBlocks" )
    Block(:block="contents" class="relative w-full md:w-[75vw] lg:w-[60vw]")
</template>

<script lang="ts">
import { defineComponent } from "vue"

export default defineComponent({
  name: "BackgroundImage",
  props: {
    block: {
      required: true,
      type: Object as () => Block
    }
  }
})
</script>

<style module lang="css">
:global(.av-background-image) {
  @screen lg {
    @apply lg:bg-blue-primary lg:bg-[url('/content-static/wp-theme/desktop-review-seo.webp')] lg:bg-no-repeat lg:bg-[-8%_100%] lg:bg-[length:50%];
  }
  @apply bg-blue-primary overflow-hidden relative;

  :global(.yellow-square) {
    @apply absolute lg:hidden z-0 bg-anyvan-yellow w-[700px] h-[700px] rounded-lg;
    bottom: -31%;
    left: 26%;
    transform: translateX(-56%) rotate(18deg);
    transform-origin: center;
  }

  iframe {
    @apply bg-white w-full rounded-lg;
  }
}
</style>
